import { errorOriginatedInMf, isErrObj, isFPPErrObj } from "../error-utils";
import { Logger } from "./index";

/**
 * Provides convenience methods to log information from a microfrontend.
 */
export abstract class AbstractLogger implements Logger {
    private static DEFAULT_ERROR_MSG = "An unknown error occurred.";

    constructor(
        protected microFrontend: string,
        protected microFrontendShorty: string,
    ) {}

    /** Logs the given error message with its details. */
    abstract logError: (message: string, stackTrace?: string, errorTraceId?: string) => void;

    /**
     * Convenience method to log a general error object.
     *
     * By default, logging is skipped if the error object is associated to a different component (microfrontend).
     * This is done in order to avoid logging the same error multiple times.
     * Logging can be force by setting the`force` parameter.
     *
     * @param error may be an arbitrary object, in particular an {@link Error} or a {@link FPPError}
     * @param force explicitly force logging, default `false`.
     */
    logErrorObj = (error: unknown, force: boolean = false): void => {
        if (typeof error === "string") {
            this.logError(error);
        } else if (isFPPErrObj(error)) {
            if (force || !errorOriginatedInMf(this.microFrontendShorty, error)) {
                this.logError(error.plainMessage, error.stack, error.errorTraceId);
            }
        } else if (isErrObj(error)) {
            const message = error.message && error.message !== "" ? error.message : AbstractLogger.DEFAULT_ERROR_MSG;
            this.logError(message, error.stack);
        } else if (error) {
            const message = AbstractLogger.DEFAULT_ERROR_MSG + " " + JSON.stringify(error);
            this.logError(message);
        } else {
            this.logError(AbstractLogger.DEFAULT_ERROR_MSG);
        }
    };
}
